import {BBModel} from '../../bb_model';
import {BaseModel} from '../base';
import {service} from '../../services/service';

class ServiceModel extends BaseModel {

    constructor(data) {
        super(...arguments);

        if (this.prices && (this.prices.length > 0)) {
            this.price = this.prices[0];
        }

        // TODO: The need for this solution should not exist with newer version of the API.
        // Fill listed_durations with missing values:
        // if durations[60, 120] and listed_durations[120] then listed_durations[120, 240]
        if (this.listed_durations[0] && this.durations[0]) {
            const multiplier = this.listed_durations[0] / this.durations[0];

            this.listed_durations = this.durations.map((duration, index) => {
                return this.listed_durations[index] ? this.listed_durations[index] : duration * multiplier;
            });
        } else {
            this.listed_durations = this.durations;
        }

        this.min_advance_datetime = moment().add(this.min_advance_period, 'seconds');
        this.max_advance_datetime = moment().add(this.max_advance_period, 'seconds');
    }

    /**
     * @description
     * Get price by duration in function of duration
     *
     * @returns {object} The returning price by duration
     */
    getPriceByDuration(dur) {
        for (let i = 0; i < this.durations.length; i++) {
            const d = this.durations[i];
            if (d === dur) {
                return this.prices[i];
            }
        }
    }

    // return price

    /**
     * @description
     * Get category promise
     *
     * @returns {object} The returning category promise
     */
    $getCategory() {
        if (!this.$has('category')) {
            return null;
        }
        const prom = this.$get('category');
        prom.then((cat) => {
                return this.category = new BBModel.Category(cat);
            }
        );
        return prom;
    }

    /**
     * @description
     * Put days in array
     *
     * @returns {array} The returning days array
     */
    days_array() {
        const arr = [];
        for (let x = this.min_bookings, end = this.max_bookings, asc = this.min_bookings <= end; asc ? x <= end : x >= end; asc ? x++ : x--) {
            let str = `${x} day`;
            if (x > 1) {
                str += 's';
            }
            arr.push({name: str, val: x});
        }
        return arr;
    }

    isDayService() {
        return !this.duration && this.duration_unit === 'day';
    }


    /**
     * @description
     * Static function that loads an array of services from a company object
     *
     * @returns {promise} A returned promise
     */
    static $query(company) {
        return service.query(company);
    }
}

export {
    ServiceModel
};
